//#region Libraries
import { useState } from "react";
import {
    useNavigate 
} from "react-router";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Styles
import { 
    Container,
    OptionList, 
    OptionListItem} from "./styles";
//#endregion
//#region Icons
import ArrowIcon from "icons/ArrowIcon";
//#endregion
//#region Utils
import useDidMount from "utils/hooks/useDidMount";
//#endregion

const DropDownButton = ({
    text = "Desplegable",
    items = [
        { path: "/", text: "Hacia...", onClick: null },
    ],
    itemSize = "big"
}) => {
    const navigate = useNavigate();
    const didMount = useDidMount();
    //#region States
    const [showOptions, setShowOptions] = useState(false);
    //#endregion
    if (!didMount)
        return null;
    return (
        <Container 
            tabIndex={1}
            onBlur={() => setShowOptions(false)}
            onFocus={() => {
                setShowOptions(true);
            }}>
            <CustomButton 
                variant="purple"
                size="big"
                text={text}
                icon={<ArrowIcon color="var(--light-1)"/>}/>
            <OptionList className={showOptions ? "visible" : ""}>
                <ul>
                    {items.map(({ path, text, onClick }, key) => {
                        return (
                            <OptionListItem 
                                key={key} 
                                className={itemSize}
                                onClick={onClick 
                                    ? () => onClick(() => navigate(path))
                                    : (() => navigate(path))}>{text}</OptionListItem>
                        );
                    })}
                </ul>
            </OptionList>
        </Container>
    );
}

export default DropDownButton;